import {
  Card,
  CardHeader,
  CardFooter,
  Pagination,
  PaginationItem,
  PaginationLink,
  Table,
  Container,
  Row,
} from "reactstrap";
// core components
import Header from "components/Headers/Header.js";
import axios from "axios";
import { useEffect, useState } from "react";
import CreaUsuario from "views/Crea/CreaUsuario";
import EditarUsuario from "./EditarUsuario";
import ProtectedRoute from "./Protected";

const Tables = () => {
  const [list1, setList1] = useState([]);
  const urlendpoint =
    "https://inspecciongnvback.azurewebsites.net/api/v1/ObtenerUsuarios";
  useEffect(() => {
    axios({
      auth: {
        username: "admin.icontec@icontec.org",
        password: "quAngEraMuSTerGerEDE",
      },
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      method: "get",

      url: urlendpoint,
    })
      .then((Response) => {
        setList1(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList1]);
  return (
    <ProtectedRoute>
      <Header />
      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0">
                <h3 className="mb-0">Usuarios</h3>
              </CardHeader>
              <div className="text-center">
                <CreaUsuario />
              </div>

              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">Id</th>
                    <th scope="col">Usuario</th>
                    <th scope="col">Nombre</th>
                    <th scope="col">Dirección</th>
                    <th scope="col"> Municipio</th>
                    <th scope="col"> Telefono</th>
                    <th scope="col"> Correo</th>
                    <th scope="col"> Tipo Usuario</th>
                    <th scope="col"> Estado</th>
                    <th scope="col"> Regional</th>
                    <th scope="col"> Editar</th>
                  </tr>
                </thead>
                <tbody>
                  {list1.map((item) => {
                    return (
                      <tr>
                        <td>{item.id}</td>
                        <td>{item.usuario}</td>
                        <td>{item.nombre}</td>
                        <td>{item.direccion}</td>
                        <td>{item.municipio}</td>
                        <td>{item.telefono}</td>
                        <td>{item.correo}</td>
                        <td>{item.tipoUsuarioId}</td>
                        <td>{item.estado}</td>
                        <td>{item.regionalId}</td>
                        <td>
                          <EditarUsuario
                            usuario={item}
                            recargarLista={() => window.location.reload()}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <CardFooter className="py-4">
                <nav aria-label="...">
                  <Pagination
                    className="pagination justify-content-end mb-0"
                    listClassName="justify-content-end mb-0"
                  >
                    <PaginationItem className="disabled">
                      <PaginationLink
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                        tabIndex="-1"
                      >
                        <i className="fas fa-angle-left" />
                        <span className="sr-only">Previous</span>
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem className="active">
                      <PaginationLink
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                      >
                        1
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem>
                      <PaginationLink
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                      >
                        2 <span className="sr-only">(current)</span>
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem>
                      <PaginationLink
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                      >
                        3
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem>
                      <PaginationLink
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                      >
                        <i className="fas fa-angle-right" />
                        <span className="sr-only">Next</span>
                      </PaginationLink>
                    </PaginationItem>
                  </Pagination>
                </nav>
              </CardFooter>
            </Card>
          </div>
        </Row>
        {/* Dark table */}
      </Container>
    </ProtectedRoute>
  );
};

export default Tables;
